import Vue from 'vue';
export default {
  INIT_COMPANIES: (state, payload) => {
    state.companies = payload;
  },
  INIT_SIMPLIFIED_COMPANIES: (state, payload) => {
    state.simplifiedCompanies = payload;
  },
  INIT_COMPANY_ARTICLES: (state, payload) => {
    state.companyArticles = payload;
  },
  INIT_COMMERCIALISTS: (state, payload)  => {
    state.commercialists = payload;
  },
  INIT_MASTER_COMPANIES: (state, payload)  => {
    state.masterCompanies = payload;
  },
  INIT_COMMERCIALISTS_FOR_COMPANIES: (state, payload) => {
    state.commercialistsForCompanies = payload;
  },
  INIT_PAGER: (state, payload) => {
    state.pager = payload;
  },
  INIT_TOWNS: (state, payload) => {
    state.towns = payload;
  },
  INIT_TOWN: (state, payload) => {
    state.town = payload;
  },
  SELECT_COMPANY: (state, payload) => {
    state.company = payload;
  },
  SELECT_COMPANY_SUPER_BONUS: (state, payload) => {
    state.superBonus = payload;
  },
  INIT_SUPER_BONUS: (state, payload) => {
    state.superBonuses = payload;
  },
  INIT_USERS: (state, payload) => {
    state.users = payload;
  },
  SELECT_USER: (state, payload) => {
    state.selectedUser = payload;
  },
  SELECT_USER_SHIPPING_INFO: (state, payload) => {
    state.userShippingInfo = payload;
  },
  INIT_TOKEN: (state, payload) => {
    state.token = payload;
  },
  INIT_PROFILE_DATA: (state, payload) => {
    localStorage.setItem('profile', JSON.stringify(payload));
    state.profile = payload;
  },
  SAVE_COMPANY: (state, payload) => {
    state.selectedCompany = payload;
  },
  INIT_COUNTRIES: (state, payload) => {
    state.countries = payload;
  },
  INIT_COUNTRY: (state, payload) => {
    state.country = payload;
  },
  INIT_SHIPPING_TOWNS: (state, payload) => {
    state.shippingTowns = payload;
  },
  INIT_USER_PROFILE: (state, payload) => {
    state.userProfile = payload;
  },

  // Categories
  INIT_CATEGORIES: (state, payload) => {
    state.categories = payload;
  },
  INIT_PARENT_CATEGORIES: (state, payload) => {
    state.parentCategories = payload;
  },
  INIT_CHILD_CATEGORIES: (state, payload) => {
    state.childCategories = payload;
  },
  INIT_SIMPLIFIED_CATEGORIES: (state, payload) => {
    state.simplifiedCategories = payload;
  },
  INIT_CATEGORY: (state, payload) => {
    state.category = payload;
  },
  CHANGE_VISIBILITY: (state, categoryId) => {
    state.categories.forEach((item) => {
      const foundCategory = item.id === categoryId;
      if (foundCategory) {
        Vue.set(item, 'childVisible', !item.childVisible);
      }
    });
  },
  INIT_CATEGORY_ARTICLES: (state, payload) => {
    state.categoryArticles = payload;
  },
  INIT_CATEGORY_PRIORITY_ARTICLES: (state, payload) => {
    state.categoryPriorityArticles = payload;
  },

  // Articles
  INIT_ARTICLES: (state, payload) => {
    state.articles = payload;
  },
  INIT_SEARCH_VARIATIONS: (state, payload) => {
    state.searchVariations = payload;
  },
  SET_ARTICLES: (state, articles) => {
    state.articles = articles;
  },
  INIT_ARTICLE: (state, payload) => {
    state.article = {
      ...payload,
      articleAttributes: payload?.articleAttributes.map((item) => ({
        ...item,
        attributePropertiesLinkedWithArticle: item.attributeValues.map((attr) => ({
          id: attr.id,
          articleId: attr.linkedArticle?.articleId, 
          articleTitle: attr.linkedArticle?.articleTitle,
          articleCode: attr.linkedArticle?.articleCode,
          articlePrice: attr.linkedArticle?.articlePrice,
          articleImage: attr.linkedArticle?.articleImage,
        })),
        attributeValues: !item.linkWithArticle ? item.attributeValues.map((attr) => attr.id) : item.attributeValues
      }))
    }
  },
  INIT_PRESENTATION_REQUESTS: (state, payload) => {
    state.presentationRequests = payload;
  },
  INIT_ARTICLE_FILTERS: (state, payload) => {
    state.articleFilters = payload;
  },
  INIT_COPY_OF_ARTICLE: (state, payload) => {
    delete payload.code;
    state.articleCopy = payload;
  },

  // Banks
  INIT_BANKS: (state, payload) => {
    state.banks = payload;
  },
  INIT_BANK: (state, payload) => {
    state.bank = payload;
  },

  // Currencies
  INIT_CURRENCIES: (state, payload) => {
    state.currencies = payload;
  },
  INIT_CURRENCY: (state, payload) => {
    state.currency = payload;
  },
  INIT_MEASUREMENT_UNITS: (state, payload) => {
    state.measurementUnits = payload;
  },
  INIT_MEASUREMENT_UNIT: (state, payload) => {
    state.measurementUnit = payload;
  },

  // Brands
  INIT_BRANDS: (state, payload) => {
    state.brands = payload;
  },
  INIT_BRAND: (state, payload) => {
    state.brand = payload;
  },

  // Taxes
  INIT_TAXES: (state, payload) => {
    state.taxes = payload;
  },

  // Express posts
  INIT_EXPRESS_POSTS: (state, payload) => {
    state.expressPosts = payload;
  },
  INIT_EXPRESS_POST: (state, payload) => {
    state.expressPost = payload;
  },

  // Tabs
  INIT_TABS: (state, payload) => {
    state.tabs = payload;
  },
  INIT_TAB: (state, payload) => {
    state.tab = payload;
  },

  // Product sales
  INIT_PRODUCT_SALES: (state, payload) => {
    state.productSales = payload;
  },
  INIT_PRODUCT_SALE: (state, payload) => {
    const dateFrom = new Date(payload.startDate);
    const dateTo = new Date(payload.endDate);
    const data = {
      ...payload, startDate: dateFrom, endDate: dateTo
    }
    state.productSale = data;
  },

  // Interests areas
  INIT_INTERESTS_AREAS: (state, payload) => {
    state.interestsAreas = payload;
  },
  INIT_INTERESTS_AREA: (state, payload) => {
    state.interestsArea = payload;
  },

  // Customer bank account
  INIT_CUSTOMER_BANK_ACCOUNTS: (state, payload) => {
    state.customerBankAccounts = payload;
  },
  INIT_CUSTOMER_BANK_ACCOUNT: (state, payload) => {
    state.customerBankAccount = payload;
  },

  // Blogs
  INIT_BLOGS: (state, payload) => {
    state.blogs = payload
  },
  INIT_BLOG: (state, payload) => {
    state.blog = payload
  },
  INIT_COPY_OF_BLOG: (state, payload) => {
    state.blogCopy = payload;
  },

  // Newsletters
  INIT_NEWSLETTERS: (state, payload) => {
    state.newsletters = payload;
  },

  // Terms of services
  INIT_TERMS_OF_SERVICES: (state, payload) => {
    state.terms = payload;
  },

  // Attributes
  INIT_ATTRIBUTES: (state, payload) => {
    state.attributes = payload;
  },
  INIT_ATTRIBUTE: (state, payload) => {
    state.attribute = payload;
  },
  INIT_ATTRIBUTE_VALUES: (state, payload) => {
    state.attributeValues = payload;
  },
  INIT_ARTICLE_VARIATIONS: (state, payload) => {
    state.articleVariations = payload;
  },
  INIT_VARIATIONS_WAREHOUSE_TOWNS: (state, payload) => {
    state.variationsWarehouseTowns = payload;
  },

  // System messages
  INIT_SYSTEM_MESSAGES: (state, payload) => {
    state.systemMessages = payload;
  },

  // Highlighted brands
  INIT_HIGHLIGHTED_BRANDS: (state, payload) => {
    state.highlightedBrands = payload;
  },
  INIT_HIGHLIGHTED_BRAND: (state, payload) => {
    state.highlightedBrand = payload;
  },

  // Jumbotrons
  INIT_JUMBOTRONS: (state, payload) => {
    state.jumbotrons = payload;
  },
  INIT_JUMBOTRON: (state, payload) => {
    state.jumbotron = payload;
  },
  INIT_HIGHLIGHTED_CATEGORIES: (state, payload) => {
    state.highlightedCategories = payload;
  },
  INIT_HIGHLIGHTED_CATEGORY: (state, payload) => {
    state.highlightedCategory = payload;
  },
  INIT_BANNERS: (state, payload) => {
    state.banners = payload;
  },
  INIT_BANNER: (state, payload) => {
    state.banner = payload;
  },
  INIT_NEWLY_ADDED_ARTICLES: (state, payload) => {
    state.newlyAddedArticles = payload;
  },
  
  // Tags
  INIT_ARTICLE_TAGS: (state, payload) => {
    state.articleTags = payload;
  },
  INIT_TAGS: (state, payload) => {
    state.tags = payload.map((item, index) => ({
      ...item,
      label: item.title,
      totalArticles: index,
    }));
  },
  INIT_TAG: (state, payload) => {
    state.tag = payload;
  },

  // Shopping carts
  INIT_SHOPPING_CARTS: (state, payload) => {
    state.shoppingCarts = payload;
  },
  INIT_SHOPPING_CART_ARTICLES: (state, payload) => {
    state.shoppingCart = payload;
  },

  // Wish lists
  INIT_WISH_LISTS: (state, payload) => {
    state.wishLists = payload;
  },
  INIT_WISH_LIST_ARTICLES: (state, payload) => {
    state.wishList = payload;
  },

  // Orders
  INIT_ORDERS: (state, payload) => {
    state.orders = payload;
  },
  INIT_ORDER: (state, payload) => {
    const articles = payload.orderItems;

    payload.orderItems = articles.map((item) => {
      return {
        ...item,
        originalQuantity: item.quantity,
      };
    });

    state.order = payload;
  },
  INIT_ORDER_STATES: (state, payload) => {
    state.orderStates = payload;
  },
  INIT_MERGE_ORDERS: (state, payload) => {
    state.mergeOrdersResponse = payload;
  },

  // Roles
  INIT_ROLES: (state, payload) => {
    state.roles = payload;
  },

  INIT_ROLES_SIMPLIFIED: (state, payload) => {
    state.simplifiedRoles = payload;
  },

  INIT_ROLE: (state, payload) => {
    state.role = payload;
  },

  // Permissions
  INIT_PERMISSIONS: (state, payload) => {
    state.permissions = payload;
  },

  // Service managers
  INIT_SERVICE_MANAGERS: (state, payload) => {
    state.serviceManagers = payload;
  },
  INIT_SERVICE_MANAGER: (state, payload) => {
    state.serviceManager = payload;
  },

  // Customer files
  INIT_CUSTOMER_FILES: (state, payload) => {
    state.customerFiles = payload;
  },
  INIT_CUSTOMER_FILE: (state, payload) => {
    state.customerFile = payload;
  },

  // Complaints
  INIT_COMPLAINTS: (state, payload) => {
    state.complaints = payload;
  },
  INIT_COMPLAINT: (state, payload) => {
    state.complaint = payload;
  },

  // Media library
  INIT_MEDIA_LIBRARY: (state, payload) => {
    state.mediaLibrary = payload;
  },

  // Meta SEO
  INIT_META_SEO: (state, payload) => {
    state.metaSeo = payload;
  },

  // Reviews
  INIT_REVIEWS: (state, payload) => {
    state.reviews = payload;
  },
  INIT_REVIEW: (state, payload) => {
    state.review = payload;
  },

  // Promo codes
  INIT_PROMO_CODES: (state, payload) => {
    state.promoCodes = payload;
  },
  INIT_PROMO_CODE: (state, payload) => {
    state.promoCode = payload;
  },

  // Gift cards
  INIT_GIFT_CARDS: (state, payload) => {
    state.giftCards = payload;
  },
  INIT_GIFT_CARD: (state, payload) => {
    const dateFrom = new Date(payload.startDate);
    const dateTo = new Date(payload.endDate);
    const data = {
      ...payload, startDate: dateFrom, endDate: dateTo
    }
    state.giftCard = data;
  },

  // Top brand list
  INIT_TOP_BRAND_LIST: (state, payload) => {
    state.topBrandList = payload;
  },

  INIT_TOP_BRAND_LIST_SINGLE: (state, payload) => {
    state.topBrandListSingle = payload;
  },

  // Offers
  INIT_OFFERS: (state, payload) => {
    state.offers = payload;
  },
  INIT_OFFER: (state, payload) => {
    state.offer = payload;
  },

  // Personal data change requests
  INIT_PERSONAL_DATA_CHANGE_REQUESTS: (state, payload) => {
    state.personalDataChangeRequests = payload;
  },
  INIT_PERSONAL_DATA_CHANGE_REQUEST: (state, payload) => {
    state.personalDataChangeRequest = payload;
  },

  // Settings
  INIT_SETTINGS: (state, payload) => {
    state.settings = payload;
  },
  INIT_SHOW_OFFERS: (state, payload) => {
    state.showOffers = payload;
  },
  INIT_SHOW_ADVANCED_OFFERS: (state, payload) => {
    state.showAdvancedOffers = payload;
  },

  INIT_B2C_SETTINGS: (state, payload) => {
    state.b2cSettings = payload;
  },

  // Cleaning areas
  INIT_CLEANING_AREAS: (state, payload) => {
    state.cleaningAreas = payload;
  },
  INIT_PARENT_CLEANING_AREAS: (state, payload) => {
    state.parentCleaningAreas = payload;
  },
  INIT_CLEANING_AREA: (state, payload) => {
    state.cleaningArea = payload;
  },

  // Cleaning plan note icons
  INIT_CLEANING_PLAN_NOTE_ICONS: (state, payload) => {
    state.cleaningPlanNoteIcons = payload;
  },
  INIT_CLEANING_PLAN_NOTE_ICON: (state, payload) => {
    state.cleaningPlanNoteIcon = payload;
  },

  // Cleaning plans
  INIT_CLEANING_PLANS: (state, payload) => {
    state.cleaningPlans = payload;
  },
  INIT_CLEANING_PLAN: (state, payload) => {
    state.cleaningPlan = payload;
  },

  // Price policies
  INIT_PRICE_POLICIES: (state, payload) => {
    state.pricePolicies = payload;
  },
  INIT_PRICE_POLICY: (state, payload) => {
    const data = { ...payload };

    data.enabled = false;
    if (data.id === 0) {
      data.startDate = new Date();
      data.endDate = new Date();
    }
    
    state.pricePolicy = data;
  },
  INIT_DEFAULT_POLICY_TYPES: (state, payload) => {
    state.defaultPricePolicyTypes = payload;
  },
  INIT_PRICE_POLICY_ITEMS: (state, payload) => {
    state.pricePolicyItems = payload;
  },

  // Dashboard
  INIT_DASHBOARD_DATA: (state, payload) => {
    state.dashboardData = payload;
  },

  // Out of stock articles
  INIT_OUT_OFF_STOCK_ARTICLES: (state, payload) => {
    state.outOfStockArticles = payload;
  },
  INIT_OUT_OFF_STOCK_ARTICLE: (state, payload) => {
    state.outOfStockArticle = payload;
  },

  // Customer requests
  INIT_CUSTOMER_REQUESTS: (state, payload) => {
    state.customerRequests = payload;
  },

  // Allowed document extensions
  INIT_ALLOWED_DOCUMENT_EXTENSIONS: (state, payload) => {
    state.allowedDocumentExtensions = payload;
  },

  // Logged user permissions
  INIT_LOGGED_USER_PERMISSIONS: (state, payload) => {
    state.loggedUserPermissions = payload;
    localStorage.setItem('user.permissions', JSON.stringify(payload));
  },
};
